import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Box, useTheme } from '@mui/material'
import React from 'react'

interface Props {
  textParts: string[]
  style?: string
  linkHref?: string
  onLinkClick?: () => void
}

/**
 * This component displays a description advertising/explaining an extension.
 */
const Description: React.FC<Props> = ({ textParts, style, linkHref, onLinkClick }) => {
  const theme = useTheme()

  const handleLinkClick = (event: React.MouseEvent): void => {
    if (!onLinkClick) return
    event.preventDefault()
    onLinkClick()
  }

  return (
    <Box className={style}>
      {textParts.map(text => (
        <Typography
          key={`description-${text.slice(0, 5)}`}
          variant="body2"
          components={{
            span: <Box component="span" sx={{ ...theme.typography.h5 }} />,
            subtitle2: <Box component="span" sx={{ ...theme.typography.subtitle2 }} />,
            ul: <Box component="ul" />,
            li: <Box component="li" />,
            strong: <Box component="strong" />,
            a: <Box component={'a'} href={linkHref} onClick={handleLinkClick} sx={{ textDecoration: 'none', color: 'primary.main' }} />,
          }}
        >
          {text}
        </Typography>
      ))}
    </Box>
  )
}

export default Description
